import React, { FormEvent } from 'react';
import {
  FormBuilder, Validators, FieldGroup, FieldControl
} from 'react-reactive-form';
import { RouteComponentProps } from 'react-router';
import { toast } from 'react-toastify';
import { PasswordInput } from '../../../components/forms/Input';
import logo from '../../../assets/img/RateChain-logo.svg';
import api from '../../../api/authentication/authentication.client';

interface ResetPasswordLocationProps {
  changePasswordId: string;
}

export default class ResetPassword extends React.PureComponent<RouteComponentProps<ResetPasswordLocationProps>> {

  form = FormBuilder.group({
    password: [ '', [ Validators.required, Validators.minLength(8) ] ],
    repeatPassword: [ '', Validators.required ],
  });

  onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (this.form.valid) {
      const { changePasswordId } = this.props.match.params;

      if (changePasswordId) {
        api.password.resetPassword(changePasswordId, { password: this.form.value.password }).then(() => {
          toast('Password changed', { type: 'success', hideProgressBar: true });
          this.props.history.push('/login');
        });
      }
    }
  };

  render() {
    return (
      <>
        <main>
          <div className="login-container col-4 offset-4">
            <div className="col-8 offset-2 mb-1">
              <img className="login-image" alt="Rate-chain" src={logo} />
            </div>
            <FieldGroup
              control={this.form}
              render={() => (
                <form className="mt-4" onSubmit={this.onSubmit}>
                  <div className="form-row">
                    <div className="col-8 offset-2">
                      <label>Password</label>
                      <FieldControl
                        name="password"
                        render={PasswordInput}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-8 offset-2">
                      <label>Repeat password</label>
                      <FieldControl
                        name="repeatPassword"
                        render={PasswordInput}
                      />
                    </div>
                  </div>
                  <div className="form-row mt-2">
                    <div className="col-8 offset-2">
                      <button name="continue" type="submit" className="btn btn-primary btn-full-size" disabled={(!this.form.valid || this.form.value.password !== this.form.value.repeatPassword)}>CONTINUE</button>
                      <button onClick={() => this.props.history.push('/login')} name="cancel" type="submit" className="btn btn-outline-secondary btn-full-size mt-1">CANCEL</button>
                    </div>
                  </div>
                </form>
              )}
            />
          </div>
        </main>
      </>
    );
  }
}
